/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NavigationCategoryModel } from '../../models/navigation-category-model';

export interface SaveNavigationCategory$Params {
      body?: NavigationCategoryModel
}

export function SaveNavigationCategory(http: HttpClient, rootUrl: string, params?: SaveNavigationCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<NavigationCategoryModel>> {
  const rb = new RequestBuilder(rootUrl, SaveNavigationCategory.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<NavigationCategoryModel>;
    })
  );
}

SaveNavigationCategory.PATH = '/api/Navigation/SaveNavigationCategory';
